(() => {
  const loaderScript = document.currentScript;
  if (!loaderScript) return;

  const sectionRoot = loaderScript.closest(".shopify-section") || document;
  const coreUrl = loaderScript.dataset.emblaCore;
  const mainUrl = loaderScript.dataset.emblaMain;
  if (!coreUrl || !mainUrl) return;

  const loadScriptOnce = (url, isReady) => {
    if (isReady()) return Promise.resolve();

    const absoluteUrl = new URL(url, document.baseURI).href;
    const existingScript = Array.from(document.scripts).find(
      (script) => script !== loaderScript && script.src === absoluteUrl
    );

    if (existingScript) {
      return new Promise((resolve, reject) => {
        if (existingScript.dataset.emblaLoaded === "true" || isReady()) {
          resolve();
          return;
        }

        existingScript.addEventListener("load", resolve, { once: true });
        existingScript.addEventListener("error", () => reject(new Error(`Unable to load ${absoluteUrl}`)), {
          once: true
        });
      });
    }

    return new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = absoluteUrl;
      script.async = false;
      script.addEventListener(
        "load",
        () => {
          script.dataset.emblaLoaded = "true";
          resolve();
        },
        { once: true }
      );
      script.addEventListener("error", () => reject(new Error(`Unable to load ${absoluteUrl}`)), { once: true });
      document.head.appendChild(script);
    });
  };

  if (!window.__emblaRuntimePromise) {
    window.__emblaRuntimePromise = loadScriptOnce(coreUrl, () => typeof window.EmblaCarousel === "function").then(
      () => loadScriptOnce(mainUrl, () => typeof window.__initEmblaCarousels === "function")
    );
  }

  window.__emblaRuntimePromise
    .then(() => {
      if (window.__emblaDocumentReady) window.__initEmblaCarousels(sectionRoot);
    })
    .catch((error) => console.error("Embla runtime failed to load", error));
})();
